// app/javascript/src/bobs/components/details/AmountStagedForPayAttempt.tsx
import React, { FC } from "react";
import { Group, Stack, Text } from "@mantine/core";
import { IconBolt } from "@tabler/icons-react";
import { PayAttempt } from "../../stores/PayAttempt";

interface PayAttemptSummaryProps {
  attempt: PayAttempt;
}

const AmountStagedForPayAttempt: FC<PayAttemptSummaryProps> = ({ attempt }) => {
  const dest = attempt.userEnteredPaymentString;
  const destDisplay =
    dest.length > 20 ? `${dest.slice(0, 12)}…${dest.slice(-8)}` : dest;

  return (
    <Stack gap={4} align="center">
      {/* sats amount */}
      <Group gap={6} wrap="nowrap">
        <IconBolt size={32} color="#00BFFF" stroke={1.3} />
        <Text fw={700} fz={28} style={{ letterSpacing: -0.4 }}>
          {attempt.payAmountSatoshis.toLocaleString()}
        </Text>
        <Text c="dimmed" fz="md">
          satoshis
        </Text>
      </Group>

      {/* fiat conversion */}
      <Text c="gray.5" fz="sm">
        {attempt.bob.formatFiat(attempt.payAmountSatoshis)}
      </Text>

      {/* destination snippet */}
      <Text
        fz="xs"
        ff="monospace"
        c="gray.6"
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          maxWidth: 240,
        }}
      >
        {destDisplay}
      </Text>
    </Stack>
  );
};

export default AmountStagedForPayAttempt;
